import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Service from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "../styles/Religion.css";

import {
  Button,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const HolidayManager = () => {
  const [holidays, setHolidays] = useState([]);
  const [regions, setRegions] = useState([]);
  const [religions, setReligions] = useState([]);

  const [form, setForm] = useState({
    id: "0",
    name: "",
    date: "",
    regionID: "",
    // religionID: "",
  });

  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchHolidays();
    fetchRegions();
    fetchReligions();
  }, []);

  const fetchHolidays = async () => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Holiday");
    const res = await Service.getAll();

    // console.log("Holiday Data From DB:", res);
    // console.log("Holiday Data:", res.data);
    setHolidays(res.data);
  };

  const fetchRegions = async () => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Region");
    const res = await Service.getAll();
    setRegions(res.data);
  };

  const fetchReligions = async () => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Religion");
    const res = await Service.getAll();
    setReligions(res.data);
  };

  const clear = () => {
    setForm({
      id: "0",
      name: "",
      date: "",
      regionID: "",
      // religionID: "",
    });
    setEditing(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const holidayName = form.name.trim();

    // 1. Holiday Name validation
    if (!holidayName) {
      setSnackbar({
        open: true,
        message: "Holiday Name is required!",
        severity: "error",
      });
      return;
    }

    // 2. Holiday Name format validation
const holidayNameRegex = /^[A-Za-z]+(?:[ -][A-Za-z]+)*$/;

if (!holidayNameRegex.test(holidayName)) {
  setSnackbar({
    open: true,
    message: "Holiday Name should contain only alphabets, spaces and hyphens!",
    severity: "error",
  });
  return;
}


    // 3. Region validation
    if (!form.regionID) {
      setSnackbar({
        open: true,
        message: "Region is required!",
        severity: "error",
      });
      return;
    }

    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Holiday");

    const response = await Service.create({
      HolidayID: form.id,
      HolidayName: holidayName, // send trimmed value
      HolidayDate: form.date,
      // RegionID: form.regionID,
      RegionID: form.regionID ? Number(form.regionID) : null,
      ReligionID: null, // force null
      OpFlag: editing ? "Update" : "Insert",
      UserName: sessionStorage.getItem("userEmail"),
    });
    // console.log("API Response:", response);
    // console.log("Response Data:", response.data);

    let vOutput = response.data.message.split(":");

    clear();
    fetchHolidays();
    setOpen(false);

    setSnackbar({
      open: true,
      message: vOutput[0],
      severity: vOutput[1],
    });
  };

  const handleEdit = (row) => {
    setForm({
      id: row.holidayID,
      name: row.holidayName,
      date: row.holidayDate?.split("T")[0],
      regionID: row.regionID,
      // religionID: row.religionID,
    });

    setEditing(true);
    setOpen(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Holiday");
    const res = await Service.remove(deleteId, "Delete");

    let vOutput = res.data.message.split(":");

    fetchHolidays();

    setSnackbar({
      open: true,
      message: vOutput[1],
      severity: vOutput[0],
    });

    setConfirmOpen(false);
  };

  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    { field: "holidayID", headerName: "ID" },

    { field: "holidayName", headerName: "Holiday Name", flex: 1 },

    {
      field: "holidayDate",
      headerName: "Date",
      flex: 1,
      renderCell: (params) => {
        if (!params.value) return "";

        const d = new Date(params.value);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
      },
    },

    //  ADD THIS COLUMN
    // {
    //   field: "regionName",
    //   headerName: "Region",
    //   flex: 1,
    // },

    {
  field: "regionName",
  headerName: "Region",
  flex: 1,
  renderCell: (params) => {
    const regionName = params.value?.trim();

    return regionName ? regionName : "N/A";
  },
},

    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.holidayID)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="religion-grid-wrapper">
      <Box sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/DashboardFinal")}
          >
            Back To Home
          </Button>

          <Button variant="contained" onClick={() => setOpen(true)}>
            Add Holiday
          </Button>
        </Box>

        <div className="datagrid-container">
          <DataGrid
            rows={holidays}
            columns={columns}
            columnVisibilityModel={{
              holidayID: false,
            }}
            getRowId={(row) => row.holidayID}
            components={{ Toolbar: GridToolbar }}
          />
        </div>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ p: 3, bgcolor: "#fff", m: "auto", mt: 10, width: 400 }}>
          <h4>{editing ? "Edit" : "Add"} Holiday</h4>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Holiday Name"
              fullWidth
              required
              value={form.name}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, name: e.target.value }))
              }
            />

            {/* <TextField
              type="date"
              fullWidth
              required
              sx={{ mt: 2 }}
              value={form.date}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, date: e.target.value }))
              }
            /> */}

            <TextField
              type="date"
              fullWidth
              required
              label="Date "
              InputLabelProps={{ shrink: true }}
              sx={{ mt: 2 }}
              value={form.date}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, date: e.target.value }))
              }
            />

            {/* Region Dropdown */}
            {/* <select
              value={form.regionID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, regionID: e.target.value }))
              }
              className="form-control mt-2"
            >
              <option value="">Select Region</option>
              {regions.map((r) => (
                <option key={r.regionId} value={r.regionId}>
                  {r.regionName}
                </option>
              ))}
            </select> */}

            <select
              value={form.regionID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, regionID: e.target.value }))
              }
              className="form-control mt-2"
              required
            >
              <option value="">Select Region *</option>

              {regions.map((r) => (
                <option key={r.regionId} value={r.regionId}>
                  {r.regionName}
                </option>
              ))}
            </select>

            {/* Religion Dropdown */}
            {/* <select
              value={form.religionID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, religionID: e.target.value }))
              }
              className="form-control mt-2"
            >
              <option value="">Select Religion</option>
              {religions.map((r) => (
                <option key={r.religionId} value={r.religionId}>
                  {r.religionName}
                </option>
              ))}
            </select> */}

            <Box mt={2} textAlign="right">
              <Button
                onClick={() => {
                  setOpen(false);
                  clear();
                }}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Delete Dialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this holiday?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default HolidayManager;
